/**
 * 帮助提示组件
 * created by liyaoh 2021-05-24
 */
import React, { useState } from "react";
import platform from "Pub/js/platform";
import { connect } from "react-redux";
import { setHelpHint, setLeftHelpTipVisible } from "Store/GridLayout/action";
import Ajax from "Pub/js/ajax";
import "./index.less";
const { NCTooltip } = platform.base;

function HelpToolTip(props) {
    const { json, isShowHelpHint, isMount, getPopupContainer } = props;
    //隐藏toolTip
    const handleHide = () => {
        props.setLeftHelpTipVisible(false);
    };

    //不再提示toolTip
    const handleNotShow = () => {
        Ajax({
            url: `/nccloud/platform/appregister/hidehint.do`,
            info: {
                name: json["DesktopSetting-000024"] /* 国际化处理： 工作桌面查询*/,
                action: json["DesktopSetting-000056"] /* 国际化处理： 不再提示*/,
            },
            success: res => {
                let { data, success } = res.data;
                if (success) {props.setHelpHint(false);}
            },
        });
    };

    const renderContent = () => {
        return (
            <div>
                <div className="help-tooltip-header">
                    <span>{json["DesktopSetting-000053"]}</span>
                    {/* 国际化处理： 提示*/}
                    <i className="iconfont icon-shenpibohui close-btn" onClick={handleHide}></i>
                </div>
                <div className="help-tooltip-content">
                    <p>{json["DesktopSetting-000054"]}</p>
                    {/* 国际化处理： 将左侧区域应用、部件拖拽至右侧工作台中，完成配置。*/}
                    {/* <p>{json["DesktopSetting-000055"]}</p> */}
                    {/* 注：常用应用、常用链接、快速发起、公共查询、指标卡、单据统计在工作台内可重复添加。*/}
                </div>
                <div className="help-tooltip-footer">
                    <span onClick={handleNotShow}>{json["DesktopSetting-000056"]}</span>
                    {/* 国际化处理： 不再提示*/}
                </div>
            </div>
        );
    };
    const toolTipVisible = isMount && isShowHelpHint && props.helpTipVisible;
    return <NCTooltip
        getPopupContainer={getPopupContainer}
        className="desktop-help-tooltip"
        placement="rightTop"
        visible={toolTipVisible}
        overlay={renderContent()}
    >
        {props.children}
    </NCTooltip>;
}
export default connect(
    state => ({
        isShowHelpHint: state.gridLayoutData.isShowHelpHint,
        helpTipVisible: state.gridLayoutData.helpTipVisible,
    }),
    {
        setHelpHint,
        setLeftHelpTipVisible,
    },
)(HelpToolTip);
